/**
 * 검색 엔진·AI 크롤러가 읽는 사이트 정보. 정적 HTML(빌드), 문서 head(SPA),
 * llms.txt가 모두 여기서 나온다. 순수 모듈: React·브라우저·node 의존 없음.
 */
export const SITE_ORIGIN = "https://crewvas.com";
export const SITE_NAME = "크루바스";
export const SITE_ALTERNATE_NAME = "Crewvas";
/** 이름을 바꾸기 전 한글 이름. 검색과 교사가 같은 서비스임을 알아보도록 계속 적는다. */
export const SITE_FORMER_NAME = "크루버스";
/** 새 이름을 처음 보는 곳에 쓰는 병기. */
export const SITE_NAME_WITH_FORMER = `${SITE_NAME}(${SITE_ALTERNATE_NAME}) · 이전 이름 ${SITE_FORMER_NAME}`;
export const SITE_CONTACT = "help@crewvas.com";
export const SITE_LOGO_URL = `${SITE_ORIGIN}/android-chrome-512x512.png`;
export const OG_IMAGE = {
  url: `${SITE_ORIGIN}/og-image.png`,
  width: 1200,
  height: 630,
  alt: "크루바스(Crewvas) - 수업의 시선이 정렬되는 곳",
} as const;

export type SeoPage = {
  /** 정규(canonical) 경로. */
  path: string;
  title: string;
  description: string;
};

export const HOME_PAGE: SeoPage = {
  path: "/",
  title: "크루바스(Crewvas) - 모둠 활동용 무료 학급 화이트보드·협업 캔버스",
  description:
    "크루바스(Crewvas) · 이전 이름 크루버스. 학생 이메일 없이 학급 계정을 한 번에 만들고, 학생별 안내문만 나눠 주면 반 전체가 한 화이트보드에서 모둠 활동을 합니다. 설명할 때는 버튼 하나로 모두 앞을 봅니다. 교사·학생 모두 무료입니다.",
};

export const MANUAL_PAGE: SeoPage = {
  path: "/manual",
  title: "이용 방법 - 크루바스(Crewvas)",
  description:
    "학급 만들기, 캔버스 만들기, 학생이 들어와 그리기까지 크루바스(이전 이름 크루버스) 첫 수업을 여는 세 단계를 실제 화면으로 보여 드립니다.",
};

export const STUDENT_MANUAL_TITLE = "학생용 안내문 - 크루바스";

export const LOGIN_TITLE = "로그인 - 크루바스";
export const UNSUBSCRIBE_TITLE = "안내 메일 수신 해지 - 크루바스";
export const DEFAULT_TITLE = "크루바스";

export const canonicalUrl = (path: string): string =>
  path === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;

/**
 * 라우트 이름별 문서 head. canonical이 있는 페이지만 색인 대상이다. 익명
 * 방문자는 앱 전용·없는 주소에서 로그인으로 보내지므로 로그인도 noindex다.
 */
export const documentHeadFor = (
  routeName: string,
): { title: string; page: SeoPage | null; noindex: boolean } => {
  switch (routeName) {
    case "home":
      return { title: HOME_PAGE.title, page: HOME_PAGE, noindex: false };
    case "manual":
      return { title: MANUAL_PAGE.title, page: MANUAL_PAGE, noindex: false };
    case "studentManual":
      return { title: STUDENT_MANUAL_TITLE, page: null, noindex: true };
    case "login":
      return { title: LOGIN_TITLE, page: null, noindex: true };
    case "unsubscribe":
      return { title: UNSUBSCRIBE_TITLE, page: null, noindex: true };
    case "account":
    case "notFound":
      return { title: DEFAULT_TITLE, page: null, noindex: true };
    default:
      return { title: DEFAULT_TITLE, page: null, noindex: false };
  }
};
